import * as React from 'react';
import classNames from 'classnames';
import useMapMarkerIconStyles from './MapMarkerIconStyles';
const isNil = require('lodash/isNil');
const MapMarkerIcon = (props) => {
    const { marker, isActive } = props;
    const classes = useMapMarkerIconStyles();
    const markerRotationAngle = marker.heading || 0;
    const hasHeading = typeof marker.heading === 'number';
    const markerElementClass = classNames(classes.markerGeneral, {
        [classes.markerGeneralWithHeading]: hasHeading,
    });
    return (React.createElement("div", { className: classes.marker, style: {
            color: marker.color,
            transform: `rotate(${markerRotationAngle}deg)`,
        } },
        React.createElement("div", { className: classes.markerCircle },
            React.createElement("div", { className: classNames(markerElementClass, classes.markerCircleGlow) }),
            React.createElement("div", { className: classNames(markerElementClass, classes.markerCircleOuter) }),
            React.createElement("div", { className: classNames(markerElementClass, classes.markerCircleInner, {
                    [classes.markerCircleInnerActive]: isActive,
                }) })),
        React.createElement("div", { className: classNames(classes.markerIcon, {
                [classes.markerIconActive]: isActive,
            }), style: { transform: `rotate(${-markerRotationAngle}deg)` } },
            marker.icon ? React.createElement("img", { src: marker.icon, style: { width: '100%' }, alt: "Marker icon" }) : null,
            marker.fontIconName ? React.createElement("span", { className: classNames(marker.icon, `icon-${marker.fontIconName}`) }) : null),
        isNil(marker.badge) ? null : (React.createElement("div", { className: classes.markerIcon, style: { transform: `rotate(${-markerRotationAngle}deg)` } },
            React.createElement("div", { className: classNames(classes.markerBadge, {
                    [classes.markerBadgeSmall]: String(marker.badge).length > 2,
                }), style: {
                    color: marker.badgeColor,
                    background: marker.badgeBackground,
                } }, marker.badge)))));
};
export default MapMarkerIcon;
//# sourceMappingURL=MapMarkerIcon.js.map